import React, { useState } from 'react';
import { X } from 'lucide-react';
import { lgcu, smcu } from '../assets/assets';
import { Header, Footer, CustomAlert } from '../components/components';
import { submitContactForm } from '../services/contact.service';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: 'success', message: '' });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.fullName || !formData.email || !formData.message) {
      setAlert({ show: true, type: 'error', message: 'Please fill in all fields' });
      return;
    }

    setLoading(true);
    try {
      const response = await submitContactForm(formData);
      setAlert({ show: true, type: 'success', message: response.message || 'Message sent successfully!' });
      setFormData({ fullName: '', email: '', message: '' });
    } catch (error) {
      setAlert({ show: true, type: 'error', message: error.error || 'Failed to send message. Please try again.' });
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      {alert.show && (
        <CustomAlert 
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ ...alert, show: false })}
        />
      )}
      <Header/>
      <div className="font-['Poppins']">
        {/* Desktop View */}
        <div className="hidden md:flex w-full">
          <div className="w-1/2">
            <img 
              src={lgcu} 
              alt="Customer service representative" 
              className="w-full h-full object-cover"
            />
          </div>
          
          <div className="w-1/2 bg-[#F5F5F5] p-8 md:p-16">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Contact Us</h1>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="desktop-fullName" className="block text-gray-700 mb-2">Full name</label>
                <input
                  type="text"
                  id="desktop-fullName"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  disabled={loading}
                  placeholder="Enter your name"
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-50"
                />
              </div>
              
              <div>
                <label htmlFor="desktop-email" className="block text-gray-700 mb-2">E-mail</label>
                <input
                  type="email"
                  id="desktop-email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={loading}
                  placeholder="Enter your email"
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-50"
                />
              </div>
              
              <div>
                <label htmlFor="desktop-message" className="block text-gray-700 mb-2">Message</label>
                <textarea
                  id="desktop-message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  disabled={loading}
                  placeholder="Your message"
                  rows="6"
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-50"
                />
              </div>
              
              <button
                type="submit"
                disabled={loading}
                className="py-3 px-6 bg-[#174568] text-white font-medium rounded-md hover:bg-gray-800 transition duration-200 disabled:bg-gray-400"
              >
                {loading ? 'Sending...' : 'Send message'}
              </button>
            </form>
          </div>
        </div>
        
        {/* Mobile View */}
        <div className="md:hidden flex flex-col min-h-screen bg-[#F5F5F5]">
        <div className="flex justify-between items-center p-4">
          <div className="text-xl font-bold">Contact Us</div>
          <a href="/"
            className="text-gray-700"
          >
            <X size={24} />
          </a>
        </div>
        
        <div className="w-[90%] mx-auto h-48 overflow-hidden">
          <img 
            src={smcu} 
            alt="Customer service representative" 
            className="w-full h-full object-cover"
          />
        </div>
        
        <div className="p-6 flex-1">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="mobile-fullName" className="block text-gray-700 mb-2">Full name</label>
              <input
                type="text"
                id="mobile-fullName"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                disabled={loading}
                placeholder="Enter your name"
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-50"
              />
            </div>
            
            <div>
              <label htmlFor="mobile-email" className="block text-gray-700 mb-2">Your Email</label>
              <input
                type="email"
                id="mobile-email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                disabled={loading}
                placeholder="Enter your email"
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-50"
              />
            </div>
            
            <div>
              <label htmlFor="mobile-message" className="block text-gray-700 mb-2">Message</label>
              <textarea
                id="mobile-message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                disabled={loading}
                placeholder="Your message"
                rows="5"
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-50"
              />
            </div>
            
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 px-4 bg-[#174568] text-white font-medium rounded-md hover:bg-gray-800 transition duration-200 disabled:bg-gray-400"
            >
              {loading ? 'Sending...' : 'Send message'}
            </button>
          </form>
        </div>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default ContactUs;